export enum AddressView {
  Search = 'search',
  Overview = 'overview',
  Edit = 'edit',
  Saved = 'saved'
}
